"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/label-has-associated-control */
const CheckboxHolder = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__CheckboxHolder",
  componentId: "design-system__y7i0co-0"
})(["label{width:22px;height:22px;border:2px solid #979797;position:relative;border-radius:", ";display:block;cursor:pointer;}input{display:none;}input:checked + label{background-color:", ";border-color:", ";path{fill:", ";}}svg{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);path{fill:transparent;}}"], _BaseTheme.default.radius.regular, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.white);

const Checkbox = _ref => {
  let {
    id,
    onChange,
    name,
    defaultChecked
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(CheckboxHolder, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: id,
    name: name,
    onChange: onChange,
    defaultChecked: defaultChecked
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "check",
    size: "14"
  })));
};

Checkbox.propTypes = {
  id: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  name: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool
};
Checkbox.defaultProps = {
  onChange: undefined,
  name: undefined,
  defaultChecked: false
};
var _default = Checkbox;
exports.default = _default;